module.exports = __webpack_public_path__ + "assets/img/ff3e690f23decaa02aec04c7c6a9256b.png";